var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{ref:"file",staticClass:"imageFile",attrs:{"accept":"image/*","prepend-icon":"","hide-input":""},on:{"change":_vm.uploadFile},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }